import React, { useState, useRef, useEffect } from "react";

export const knockCustomList = [
  {
    index: 0,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight01.jpg",
    mime_type: "image/png",
    store_id: 2538,
    type: "adver",
  },
  {
    index: 1,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight02.jpg",
    mime_type: "image/png",
    store_id: 2530,
    type: "adver",
  },
  {
    index: 2,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight03.jpg",
    mime_type: "image/png",
    store_id: 2622,
    type: "adver",
  },
];

const CustomKkhotel = (props: { navigateAdStore: any; adverClick: any }) => {
  const renderButtons = (idx: number, storeId: number) => {
    return (
      <>
        <img
          src={`${
            idx === 0
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive01.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button01.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(101);
            props.adverClick(101, "순대국");
          }}
        />
        <img
          src={`${
            idx === 1
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive02.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button02.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(103);
            props.adverClick(103, "아란쿠차");
          }}
        />
        <img
          src={`${
            idx === 2
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive03.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button03.png"
          }`}
          width={"50%"}
          onClick={() => props.navigateAdStore(2622, "adver")}
        />
        <img
          src={`${
            idx === 3
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive04.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button04.png"
          }`}
          width={"50%"}
          onClick={() => props.navigateAdStore(2543, "adver")}
        />
        <img
          src={`${
            idx === 4
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive05.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button05.png"
          }`}
          width={"50%"}
          onClick={() => props.navigateAdStore(2508, "adver")}
        />
      </>
    );
  };

  return (
    <>
      {knockCustomList.map((data: any, index: number) => (
        <div
          style={{
            position: "relative",
          }}
          className="adverStoreWrap"
          key={index}
        >
          <div key={index}>
            {data.mime_type.includes("image") && (
              <div className="imageBox">
                <img className="adImg" src={data.url_path} alt="광고이미지" />
              </div>
            )}
            {data.mime_type.includes("video") && (
              <div className="imageBox">
                <video
                  className="adVideo"
                  id={`adVideo${index}`}
                  autoPlay
                  preload="auto"
                  muted
                  loop
                >
                  <source src={data.full_path} type="video/mp4" />
                </video>
              </div>
            )}
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              right: "3%",
              textAlign: "right",
            }}
          >
            <div className="customButtonWrap">
              {renderButtons(data.index, data.store_id)}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default CustomKkhotel;
